// extracted by mini-css-extract-plugin
module.exports = {"textColorBlack":"DeviceHoverCard_textColorBlack__DE0TX","content":"DeviceHoverCard_content__2R5fJ","datIndex":"DeviceHoverCard_datIndex__1hGLV"};